<template>
    <div>
        
        <b-row>
            <b-tabs content-class="mt-3" v-model="tabIndex">
                <b-tab title="En gestión" active :title-link-class="getTabClass(0)">
                    <b-row>
                        <b-col>
                            <app-filters @filters="onFilter" @clear="onClearFilters"></app-filters>
                        </b-col>
                    </b-row>
                    <b-col>
                        <app-list
                            ref="open-tasks-list"
                            @edit-task="onEditTask"
                            @new-task="openModal('task-form-window')"
                            :filters="openTaskFilters"
                            @refresh-closed-tasks="onRefreshClosedTasks"
                            @refresh-archived-tasks="onRefreshArchivedTasks"
                        />
                    </b-col>
                </b-tab>
                <b-tab title="Finalizadas" :title-link-class="getTabClass(1)">
                    <b-row>
                        <b-col>
                            <app-filters @filters="onFilter" @clear="onClearFilters"></app-filters>
                        </b-col>
                    </b-row>
                    <b-col>
                        <app-closed-list
                            ref="closed-tasks-list"
                            :filters="closedTaskFilters"
                        />
                    </b-col>
                </b-tab>
                <b-tab title="Archivadas" :title-link-class="getTabClass(2)">
                    <b-row>
                        <b-col>
                            <app-filters @filters="onFilter" @clear="onClearFilters"></app-filters>
                        </b-col>
                    </b-row>
                    <b-col>
                        <app-archived-list
                            ref="archived-tasks-list"
                            :filters="archivedTaskFilters"
                        />
                    </b-col>
                </b-tab>
            </b-tabs>
        </b-row>
        <app-modal
            title="Formulario de tarea administrativa"
            id="task-form-window"
            size="xl"
            hide-footer
            :tall="true"
        >
            <app-form ref="task-form" @success="onSuccess" @cancel="onCancel"/>
        </app-modal>
    </div>
</template>
<script>
import appList from './List.vue'
import appForm from './Form.vue'
import appFilters from './Filters.vue'
import appClosedList from './ClosedList.vue'
import appArchivedList from './ArchivedList.vue'
export default {
    components: {
        appList,
        appForm,
        appFilters,
        appClosedList,
        appArchivedList
    },
    data: () => ({ 
        task: [], 
        openTaskFilters: {}, // Filtros para tareas abiertas
        closedTaskFilters: {}, // Filtros para tareas cerradas 
        archivedTaskFilters: {}, // Filtros para tareas archivadas
        tabIndex: 0,
    }),
    methods: {
        onSuccess(msg) {
            toastr.success(msg)
            this.closeModal('task-form-window')
            this.$refs['open-tasks-list'].refreshTable()
            this.$refs['closed-tasks-list'].refreshTable();
        },
        onCancel() {
            this.closeModal('task-form-window')
        },
        onEditTask(task) {
            this.openModal('task-form-window')
            this.$nextTick(() => this.$refs['task-form'].edit(task))
        },
        onFilter(filters) {
            if (this.tabIndex === 0) {
                this.openTaskFilters = filters;
                this.$refs['open-tasks-list'].refreshTable();
            } else if (this.tabIndex === 1) {
                this.closedTaskFilters = filters;
                this.$refs['closed-tasks-list'].refreshTable();
            }else if (this.tabIndex === 2) {
                this.archivedTaskFilters = filters;
                this.$refs['archived-tasks-list'].refreshTable();
            }

        },
        onClearFilters() {
            if (this.tabIndex === 0) {
                this.openTaskFilters = {};
                this.$refs['open-tasks-list'].refreshTable();
            } else if (this.tabIndex === 1) {
                this.closedTaskFilters = {};
                this.$refs['closed-tasks-list'].refreshTable();
            }else if (this.tabIndex === 2) {
                this.archivedTaskFilters = {};
                this.$refs['archived-tasks-list'].refreshTable();
            }
        },
        getTabClass(idx) {
            return this.tabIndex === idx ? ['bg-orange', 'text-white'] : ''
        },
        onRefreshClosedTasks() {
            this.$refs['closed-tasks-list'].refreshTable()
        },
        onRefreshArchivedTasks() {
            this.$refs['archived-tasks-list'].refreshTable()
        }
    },
}
</script>
